import React from 'react';
import { IBasicCheckBox } from '../../../interfaces/buttons/buttons';

const BasicCheckBox = ({ id, isChecked, onChange, label, isDisabled }: IBasicCheckBox) => {
    return (
        <label className="basic-checkbox-wrapper">
            <svg className="basic-checkbox-symbol" aria-hidden="true">
                <symbol id="check" viewBox="0 0 18 6">
                    <polyline
                        points="2 6 4.5 8 9.5 1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                </symbol>
            </svg>

            <div className={`basic-checkbox-container ${isDisabled ? "disabled-checkbox" : ""}`}>
                <input
                    className="basic-checkbox-input"
                    disabled={isDisabled}
                    id={id}
                    type="checkbox"
                    checked={isChecked}
                    onChange={onChange}
                    aria-label={label}
                    aria-checked={isChecked}
                />

                <span className="basic-checkbox" aria-hidden="true">
                    <span>
                        <svg width="12px" height="10px">
                            <use xlinkHref="#check"></use>
                        </svg>
                    </span>
                </span>
            </div>

            <span className="label-text">{label}</span>
        </label>
    );
};

export default BasicCheckBox;
